import {
  s3AuditInstallCommands,
  s3AuditInstallTerraform,
} from "@p0security/integrations-aws-s3-audit-shared";
import { otherInstalledIntegration } from "@p0security/integrations-installer";
import { Typography } from "@p0security/ui";

import type { AwsS3AuditInstaller } from "./types";

export const awsS3AuditInstaller: AwsS3AuditInstaller = {
  components: {
    "audit-log": {
      instructions: (context, id, item) => {
        const { accountId, awsPartition, serviceAccountId } = item ?? {};
        if (!accountId || !serviceAccountId) return {};
        const args = {
          accountId,
          bucket: id,
          gcloudServiceAccountId: serviceAccountId,
          partition: awsPartition?.type ?? "aws",
        };
        return {
          help: (
            <>
              Create P0&apos;s role in AWS account {accountId} so P0 can write
              audit log files to {id}. Run these commands in{" "}
              <Typography.Link
                href={`https://${accountId}.signin.aws.amazon.com/console`}
                target="_blank"
                rel="noopener"
              >
                AWS CloudShell
              </Typography.Link>
              , or apply the Terraform:
            </>
          ),
          commands: {
            shell: [{ command: s3AuditInstallCommands(context, args) }],
            iac: [{ command: s3AuditInstallTerraform(context, args) }],
          },
        };
      },
      items: {
        // P0 assumes the role with the service account of the account's AWS
        // integration, so only accounts with that integration are offered
        accountId: {
          optionProvider: otherInstalledIntegration({
            integration: "aws",
            component: "base",
          }),
        },
        awsPartition: { options: {} },
        region: {},
        serviceAccountEmail: {},
        serviceAccountId: {},
      },
    },
  },
};
